import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  IconIndustrialPollution,
  IconMaterialCost,
  IconHazardousWaste,
  IconPlasticWaste,
  IconUploadFile,
  IconCopyPasteData,
  IconReport,
  IconTrainingCourse,
  IconSwapOutGuide,
  IconHealthPack,
  IconMoneyBag,
} from "./icons";
import IconBusinessCase from "./icons/IconBusinessCase";
import IconBusinessClient from "./icons/IconBusinessClient";
import StatsCard from "./atoms/StatsCard";

function ForeThoughtTool() {
  const location = useLocation();
  const navigate = useNavigate();

  const differenceData = location.state?.differenceData || {
    costTotal: "€0",
    co2eTotal: "0 kg",
    plasticTotal: "0 kg",
    hazardCodeScore: "N/A",
  };

  const handleDownload = (documentName) => {
    const link = document.createElement("a");
    link.href = `${process.env.PUBLIC_URL}/Files/TestData.pdf`;
    link.download = `${documentName}.pdf`;
    link.click();
  };


  return (
    <>
      <div className="container">
        <div className="flex-container">
          <h1>Report & Action</h1>

          <div className="stats-container">
            <h2 className="grid-container-header">
              Congratulations:{" "}
              <span className="font-normal">Your choices will eliminate:</span>
            </h2>
            <div
              className="grid-container"
              style={{
                "--cardTextColor": "var(--color-black)",
                "--cardTextDetailColor": "var(--color-primary)",
                "--cardBgColor": "var(--color-secondary)",
              }}
            >
              <StatsCard
                large
                title="Carbon Emission"
                value={differenceData.co2eTotal}
                icon={<IconIndustrialPollution />}
              />
              <StatsCard
                large
                title="Plastic Packaging"
                value={differenceData.plasticTotal}
                icon={<IconPlasticWaste />}
              />
              <StatsCard
                large
                title="Material Costs"
                value={differenceData.costTotal}
                icon={<IconMaterialCost />}
              />
              <StatsCard
                large
                title="Hazardous Products"
                value={differenceData.hazardCodeScore}
                icon={<IconHazardousWaste />}
              />
            </div>
          </div>

          <div className="stats-container">
            <h2>Take Action</h2>
            <div
              className="grid-container"
              style={{
                "--grid-cols": 3,
                "--min-col-width": "320px",
                "--cardTextColor": "var(--color-black)",
                "--cardTextDetailColor": "var(--color-primary)",
                "--cardBgColor": "var(--color-secondary)",
              }}
            >
              <div className="action-card large">
                <IconReport />
                <div className="content">
                  <p>Impact Report</p>
                  <button onClick={() => handleDownload()} style={{"--margin": "8px 0 0", "--padding": "12px 16px", "--width": "auto" }}>
                    Download
                  </button>
                </div>
              </div>
              <div className="action-card large">
                <IconBusinessCase />
                <div className="content">
                  <p>Business Case</p>
                  <button onClick={() => handleDownload()} style={{"--margin": "8px 0 0", "--padding": "12px 16px", "--width": "auto" }}>
                    Download
                  </button>
                </div>
              </div>
              <div className="action-card large">
                <IconBusinessClient />
                <div className="content">
                  <p>Business Case (Client)</p>
                  <button onClick={() => handleDownload()} style={{"--margin": "8px 0 0", "--padding": "12px 16px", "--width": "auto" }}>
                    Download
                  </button>
                </div>
              </div>
              <div className="action-card large">
                <IconTrainingCourse />
                <div className="content">
                  <p>Training Course</p>
                  <button onClick={() => handleDownload()} style={{"--margin": "8px 0 0", "--padding": "12px 16px", "--width": "auto" }}>
                    Download
                  </button>
                </div>
              </div>
              <div className="action-card large">
                <IconSwapOutGuide />
                <div className="content">
                  <p>Swap-out Guide</p>
                  <button style={{"--margin": "8px 0 0", "--padding": "12px 16px", "--width": "auto" }}>Download</button>
                </div>
              </div>
              <div className="action-card large">
                <IconHealthPack />
                <div className="content">
                  <p>Health & Safety Pack</p>
                  <button onClick={() => handleDownload()} style={{"--margin": "8px 0 0", "--padding": "12px 16px", "--width": "auto" }}>
                    Download
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ForeThoughtTool;
